import React, { useState } from "react";
import { Car } from "../Types/Car";
import defaultHeaderPhoto from "../../defaultHeaderPhoto.png";
import "./CarCard.css";
import { imageServerUrl, imageSizes } from "../../constants/config";
import { useNavigate } from "react-router";
interface CarCardProps {
  car: Car;
}

const CarCard: React.FC<CarCardProps> = ({ car }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const navigate=useNavigate();

  const getImageUrl = (id: string | undefined, size: string): string => {
    if (!id) return defaultHeaderPhoto;
    return `${imageServerUrl}/image/${size}/${id}`;
  };

  const handleNextImage = (e: React.MouseEvent) => {
    e.stopPropagation();
    setCurrentImageIndex((prevIndex) =>
      prevIndex === car.images.length - 1 ? 0 : prevIndex + 1
    );
  }
  const handlePrevImage = (e: React.MouseEvent) => {
    e.stopPropagation();
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? car.images.length - 1 : prevIndex - 1
    );
  }
  return (
    <div className="car-card"  onClick={() => navigate(`/car/${car.ID}`)}>
      <div className="car-card-image-box">
       {car.images.length > 0 ? (
         <img
          src={getImageUrl(car?.images[currentImageIndex]?.ID, imageSizes.large)}
          onError={(e) => { (e.target as HTMLImageElement).src = defaultHeaderPhoto; }}
          alt={`${car.make} ${car.model}`}
          loading="lazy"
        />
       ) : (
         <img src={defaultHeaderPhoto} alt={`${car.make} ${car.model}`} />
       )}
        <div onClick={handleNextImage} className="car-card-next"> {">"} </div>
        <div onClick={handlePrevImage} className="car-card-prev"> {"<"} </div>
      </div>
      <div className="car-card-content">
        <div className="car-card-header">
          <div className="car-card-title">
            <div className="car-card-make-model">
              {car.make} {car.model}
            </div>
            <div className="car-card-year">{car.yearOfRegistration}</div>
          </div>
          <div className="car-card-description">{car.modelTypeName}</div>
        </div>
        <div className="car-card-items">
          <p className="content-pill">{car.driveType}</p>
          <p className="content-pill">{car.fuelType}</p>
          <p className="content-pill">{car.mileage}</p>
          <p className="content-pill">{car.yearOfRegistration}</p>
        </div>
        <div className="car-card-price-container">
          <div className="car-card-price-text">Hinta</div>
          <div className="car-card-price">{car.price}€</div>
        </div>
        <button 
        className="car-card-button"
        onClick={() => navigate(`/car/${car.ID}`)}
        >Katso auton tiedot</button>
      </div>
    </div>
  );
};

export default CarCard;
